import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// PlusButton.tsx -- corner-fixed FAB. Click opens PlusMenu.
//
// Per design \u00a76.1 it lives in the lower-right of the desktop. Clicking it
// opens the small popover (PlusMenu) with hint-driven agent options.
import { useEffect, useRef, useState } from 'react';
import { PlusMenu } from './PlusMenu.js';
export function PlusButton(props) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        if (!open)
            return;
        const onDocClick = (e) => {
            if (ref.current && !ref.current.contains(e.target))
                setOpen(false);
        };
        const onKey = (e) => {
            if (e.key === 'Escape')
                setOpen(false);
        };
        document.addEventListener('mousedown', onDocClick);
        document.addEventListener('keydown', onKey);
        return () => {
            document.removeEventListener('mousedown', onDocClick);
            document.removeEventListener('keydown', onKey);
        };
    }, [open]);
    return (_jsxs("div", { ref: ref, className: "plus-host", children: [open && (_jsx(PlusMenu, { onCreateFolder: () => { setOpen(false); props.onCreateFolder(); }, onUploadDocument: () => { setOpen(false); props.onUploadDocument(); }, onAICreateDocument: () => { setOpen(false); props.onAICreateDocument(); }, onCoWorkers: () => { setOpen(false); props.onCoWorkers(); }, onMembers: () => { setOpen(false); props.onMembers(); }, onConversations: () => { setOpen(false); props.onConversations(); } })), _jsx("button", { type: "button", className: `plus-button ${open ? 'open' : ''}`, onClick: () => setOpen((o) => !o), title: "New (folder, upload, AI create)", "aria-label": "Add", "aria-expanded": open, children: _jsx("span", { className: "plus-glyph", "aria-hidden": true, children: "+" }) })] }));
}
